import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { CustomersContext, ICustomersContext } from '../../../../../customersState/customersContext';
import style from './DropdownMenu.module.scss';

const DropdownMenu: React.FC = () => {
	const { setSortBy, sortBy } = useContext<ICustomersContext>(CustomersContext);

	return (
		<div className={style.container} data-test="DropdownMenu">
			<div className={style.resetWrapper}>
				<span className={style.resetBtn} onClick={() => setSortBy('')}>
					<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
				</span>
			</div>

			<div className={style.item}>
				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortByNameLabel"
						theme="neutralLight"
						size="xs"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByNameA-Z" size="xs" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('NameA-Z')}
						checked={sortBy === 'NameA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByNameZ-A" size="xs" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('NameZ-A')}
						checked={sortBy === 'NameZ-A'}
						name="assignmentSort"
					/>
				</label>

				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortByRestHotelLabel"
						theme="neutralLight"
						size="xs"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByRestHotel1-10" size="xs" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('Rest/Hotel1-10')}
						checked={sortBy === 'Rest/Hotel1-10'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByRestHotel10-1" size="xs" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('Rest/Hotel10-1')}
						checked={sortBy === 'Rest/Hotel10-1'}
						name="assignmentSort"
					/>
				</label>
			</div>
		</div>
	);
};

export default DropdownMenu;
